import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Tooltip from "@/v2-ui/tooltip"
import { padDailyHistory } from "@/v2-backoffice-client/uptime/uptime.utils"
import type { UptimeTargetFragment } from "@/v2-backoffice-client/uptime/__types__/uptime.fragment"

export type UptimeHistoryBarProps = ComponentProps<"div"> & {
  history: UptimeTargetFragment["DailyHistory"]
  // Number of cells to render (defaults to 90 to mirror GitHub status).
  days?: number
}

function UptimeHistoryBar(props: UptimeHistoryBarProps) {
  const { history, days = 90, className, ...divProps } = props

  const padded = padDailyHistory(history, days)

  return (
    <div
      className={cn("uptime-history-bar", className)}
      role="img"
      aria-label={`${days}-day status history`}
      {...divProps}
    >
      {padded.map((cell, i) => {
        const variant =
          cell == null
            ? "empty"
            : cell.Status === "down"
              ? "down"
              : cell.Status === "skipped"
                ? "skipped"
                : "up"

        const label =
          cell == null
            ? "No data"
            : cell.Status === "down"
              ? `${cell.Date}: ${cell.DownChecks} of ${cell.TotalChecks} checks failed`
              : `${cell.Date}: all ${cell.TotalChecks} checks ${cell.Status}`

        return (
          <Tooltip key={i}>
            <Tooltip.Trigger asChild>
              <div
                className={cn(
                  "uptime-history-bar-cell",
                  `uptime-history-bar-cell-${variant}`,
                )}
              />
            </Tooltip.Trigger>
            <Tooltip.Content side="top">{label}</Tooltip.Content>
          </Tooltip>
        )
      })}
    </div>
  )
}

export default UptimeHistoryBar
